export const EMAIL_SETTINGS_TITLE_ID = 'email-settings-title';
export const EMAIL_SETTINGS_DESCRIPTION_ID = 'email-settings-description';

export const DEFAULT_PAGE_SIZE = 3;
export const SEARCH_PAGE_SIZE = 50;

export const EMAIL_AUTOMATION_IDS = {
	SECTION: 'email-settings',
	RECIPIENTS_SELECT: 'email-recipients-select',
	RECIPIENTS_CHIPS: 'email-recipients-chips',
	ADDED_RECIPIENTS_TITLE: 'added-recipients-title'
} as const;
